import React, {useEffect, useMemo, useState} from 'react';
import {
    useActiveProjectCalendarsSelector,
    useChecklistMapSelector,
    useCpmMapSelector
} from "../../../../store/selectors/project.selectors";
import {
    useAllTaskListSelector,
    useCompletedChecklistMapSelector
} from "../../../../store/selectors/task/task.selectors";
import TaskStatusModel from "../../../../models/responses/task-status.model";
import {convertIndexToSeconds} from "../../../../utils/cpm-functions/cpm-app/functions/handleEvent";
import {useSearchParamatersSelector} from "../../../../store/selectors/search.selectors";
import filterTaskList from "../../../../utils/task-filtering";
import styles from "./Checklist.module.scss";
import CheckListItems from "./components/CheckListItems";

export default function CheckListPage() {
    const allTasks = useAllTaskListSelector();
    const cpmMap = useCpmMapSelector();
    const calendarMap = useActiveProjectCalendarsSelector();
    const checklistMap = useChecklistMapSelector();
    const searchParams = useSearchParamatersSelector();
    const completedChecklistMap = useCompletedChecklistMapSelector();
    const [dueItems, setDueItems] = useState<any>([]);
    const [plannedItems, setPlannedItems] = useState<any>([]);
    const [completedItems, setCompletedItems] = useState<any>([]);

    const checklistTasks = useMemo(() => {
        let incompleteChecklistItems: any = [];
        filterTaskList(allTasks, searchParams, cpmMap, calendarMap).forEach(task => {
            if (task.status === TaskStatusModel.COMPLETE || task.status === TaskStatusModel.DECLARED_COMPLETE) return;
            if (!task.checklistId) return;
            const cpmTask = cpmMap.get(task.task_id);
            const checklist = checklistMap.get(task.checklistId);
            if (!cpmTask || !checklist) return;
            const workingHours = calendarMap.get(`whd:${cpmTask.cal_id}`)
            checklist.items.forEach((checklistItem: any) => incompleteChecklistItems.push({
                ...checklistItem,
                taskId: task.task_id,
                taskString: task.wbsPath ? `${task.wbsPath} / ${task.task_name} (${task.task_code})` :
                    `${task.task_name} (${task.task_code})`,
                due: checklistItem.tMinusDays > 0 ?
                    convertIndexToSeconds((cpmTask.ff ? cpmTask.ff : cpmTask.ef) + (checklistItem.tMinusDays * workingHours * 2), cpmTask.cal_id, calendarMap) :
                    convertIndexToSeconds((cpmTask.fs ? cpmTask.fs : cpmTask.es) + (checklistItem.tMinusDays * workingHours * 2), cpmTask.cal_id, calendarMap),
                completionRecord: completedChecklistMap.get(`${task.task_id}:${checklistItem.checklistItemId}`),
            }));
        })
        return incompleteChecklistItems.sort((a, b) => a.due - b.due);
    }, [allTasks, searchParams])

    useEffect(() => {
        if (!checklistTasks.length) {
            setDueItems([]);
            setPlannedItems([]);
            return
        }
        let dueOut: any = [];
        let plannedOut: any = [];
        let completedItems: any = [];
        let index = 0;
        checklistTasks.forEach((item: any) => {
            if (item.completionRecord && item.completionRecord.timestamp.seconds > new Date().getTime() / 1000 - 604800) {
                completedItems.push(item);
            } else if (item.due * 1000 <= new Date().getTime()) {
                dueOut.push({...item, index: index + 1});
                index++;
            } else {
                plannedOut.push({...item, index: index + 1});
                index++;
            }
        })
        setDueItems(dueOut);
        setPlannedItems(plannedOut);
        setCompletedItems(completedItems.sort((a, b) =>
            b.completionRecord.timestamp.seconds - a.completionRecord.timestamp.seconds));
    }, [checklistTasks]);

    return (
        <div style={{minWidth: "100%", maxWidth: "100%", overflow: "hidden"}}>
            <div className={styles.ChecklistHeaders}>
                <div className={styles.ChecklistHeadersLeft}>
                    <div className={styles.ChecklistHeader}>Priority</div>
                </div>
                <div className={styles.ChecklistHeadersRight}>
                    <div className={styles.ChecklistHeader}>Due Date</div>
                    <div className={styles.ChecklistHeaderRightAligned}>Deadline</div>
                </div>
            </div>
            <div
                id="cl-container"
                className={styles.ChecklistSectionContainer}
                style={{
                    maxHeight: `calc(100vh - 180px)`,
                    minWidth: "100%",
                    overflowX: "hidden",
                    overflowY: "auto"
            }}
            >
                <CheckListItems
                    checkListItemList={completedItems}
                    title="Completed (last 7 days)"
                />
                <CheckListItems
                    checkListItemList={dueItems}
                    title="Due"
                />
                <CheckListItems
                    checkListItemList={plannedItems}
                    title="Planned"
                />
            </div>
        </div>
    )
}